export const ANDREA_UNLOCK_NOTICE_COOKIE = 'luci_andrea_unlock_notice_dismissed';

export interface AssistToastContext {
  routeVisible: boolean;
  isAuthenticated: boolean;
  isDismissed: (cookieKey: string) => boolean;
}

export interface AssistToastDefinition {
  id: string;
  message: string;
  ackLabel?: string;
  dismissCookieKey: string;
  durationMs?: number;
  shouldShow: (ctx: AssistToastContext) => boolean;
}

export const ASSIST_TOAST_REGISTRY: AssistToastDefinition[] = [
  {
    id: 'andrea-unlock',
    message: 'New interview model unlocked! Choose Andrea (fast) from settings!',
    dismissCookieKey: ANDREA_UNLOCK_NOTICE_COOKIE,
    shouldShow: ({ routeVisible, isAuthenticated, isDismissed }) =>
      routeVisible
      && isAuthenticated
      && !isDismissed(ANDREA_UNLOCK_NOTICE_COOKIE),
  },
];
